// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2G-Gy","title":"InfoRow_title__1Rn2Q"};